import { Component, OnInit, ViewChild, Output, EventEmitter, HostListener} from '@angular/core';
import { ModalComponent } from '../../../../../core/shared/modal/modal.component';
import { SystemVersionRest } from '../../../../../configuration/system-versions/system-versions.rest';
import { CustomersRest } from '../../../customers.rest';
import { ObjectToSelect } from '../../../../../core/shared/objectToSelect.model';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-system-versions-selection',
  templateUrl: './system-versions-selection.component.html'
})
export class SystemVersionsSelectionComponent implements OnInit {

  private systemVersions: ObjectToSelect[];
  public systemVersion: ObjectToSelect;
  private customerId: number;
  private systemVersionsOpen = false;
  private isSaving = false;

  constructor(private systemVersionRest: SystemVersionRest,
    private customerRest: CustomersRest) { }

  @ViewChild('systemVersionSelectionForm') systemVersionSelectionForm: NgForm;
  @ViewChild(ModalComponent) public modal: ModalComponent;
  @Output() onSuccess: EventEmitter<any> = new EventEmitter();

  @HostListener('document:keydown.control.s', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.modal.modalRoot.isShown === true && this.systemVersionSelectionForm.valid) {
      this.confirm();
      event.preventDefault();
    }
  }

  ngOnInit() {
    this.modal.title = 'Dodaj wersję systemu';
    this.systemVersion = new ObjectToSelect;
  }

  public openModal(customerId: number) {
    this.customerId = customerId;
    const action = this.systemVersionRest.getSystemVersionsToSelect;
    action.call(this.systemVersionRest).subscribe((systemVersions: ObjectToSelect[]) => {
        if (systemVersions) {
          this.systemVersions = systemVersions;
          this.systemVersion = systemVersions[0];
        }
    });
    this.modal.open();
  }

  public closeModal() {
    this.modal.close();
  }

  private confirm() {
    if (this.isSaving) {
      return;
    }
    if (this.customerId !== 0) {
      this.isSaving = true;
      const action = this.customerRest.addCustomerSystemVersion;
      action.call(this.customerRest, this.customerId, this.systemVersion.id).subscribe((result: any) => {
        let emmitData = {isSuccess: true, systemVersion: result, isSaved: true};
        this.onSuccess.emit(emmitData);
        this.isSaving = false;
      });
    } else {
      this.isSaving = true;
      let emmitData = {isSuccess: true, systemVersion: this.systemVersion, isSaved: false};
      this.onSuccess.emit(emmitData);
      this.isSaving = false;
    }
    this.modal.close();
  }


}

